import React from 'react';
import '../styles.css';

function AttemptBox(props) {

    let bgcolor = '';

    if (props.bool === 'correct') {
        bgcolor = '#04cc00';
    } else if (props.bool === 'incorrect') {
        bgcolor = '#d70000';
    }

    return (
        <div className='attemptBox' style={{backgroundColor:bgcolor}}>
            {props.letter}
        </div>
    );
}

export default AttemptBox;